import { React, useState } from 'react';
import { Dialog } from '@mui/material';
import axios from 'axios';
import { toast } from 'react-toastify';
import { ButtonComponent } from 'component/Button';
import { ReactComponent as CancelSvg } from 'assets/images/icons/close_24px.svg';
import { ReactComponent as DownloadSvg } from 'assets/images/icons/file_download.svg';
import { ReactComponent as AddSvg } from 'assets/images/icons/add_24px.svg';
import { ReactComponent as ShedulleSvg } from 'assets/images/icons/Shedulle.svg';
import { InputComponent } from 'component/Input';
import { SelectComponent } from 'component/Select';
import { axiosWrapper } from 'utils/Helper';
import {
  EOREBlocks,
  EORETemplate,
  HABlocks, HATemplate, NTSBlocks, NTSTemplate,
} from 'consts/Templates';
import 'assets/styles/pages/templates.scss';
import { useUser } from 'routes/UserContext';
import { NTSAttributesBlock } from './NTSAttributes';
import { HAAttributesBlock } from './HAAtrributes';
import { EoreAttributesBlock } from './EoreAttributes';
import { CLEARANCE_SCHEMA } from './ClearanceSchema';
import { CLEARANCE_DAILY_SCHEMA } from './ClearanceDailySchema';
import { CLEARANCE_WEEKLY_SCHEMA } from './ClearanceWeeklySchema';

const CLEARANCE_DEFAULT_FIELDS = {
  ha: {
    general: {
      imsma_id: true,
      hazard_name: true,
      internal_id: true,
      reporter_organization: true,
    },
    location: {
      region: true,
      district: true,
      local_community: true,
      settlement_name: true,
    },
    turn_points: {
      points: true,
      total_area_meters: true,
    },
  },
  gis: {
    deminers_polygon: true,
    deminers_files_links: true,
  },
  tcp: {
    user: true,
    donor: true,
    task_customer: true,
    methods: true,
    imsma_id: true,
    start_date: true,
    internal_id: true,
    estimate_days: true,
    position_user: true,
  },
  team: {
    related_users: true,
  },
  files: {
    files: true,
  },
  cl_task_id: {
    id: true,
  },
  created_at: {
    created_at: true,
  },
  progress_map: {
    crosshair: true,
  },
  comments_summary: {
    comments_summary: true,
    imsma_comments_summary: true,
    status_manually_changed: true,
    display_validation_status: true,
  },
};

const CLEARANCE_DAILY_DEFAULT_FIELDS = {
  dms: {
    user: true,
    donor: true,
    task_customer: true,
    team_id: true,
    report_date: true,
    maintenance_day: true,
    reporter_position: true,
    reporter_organization: true,
    maintenance_day_exists: true,
  },
  marking: {
    area: true,
    points: true,
    marking_files: true,
    marking_remarks: true,
  },
  created_at: {
    created_at: true,
  },
  field_work: {
    ha_id: true,
    region: true,
    remarks: true,
    district: true,
    eo_found: true,
    task_type: true,
    local_community: true,
    settlement_name: true,
    daily_progress_polygon: true,
    clearance_task_imsma_id: true,
    field_work_cleared_area: true,
    deminer_progress_polygon: true,
    number_of_deminers_on_the_field: true,
  },
  cl_daily_id: {
    id: true,
  },
  eo_found_tab: {
    ied: true,
    saa: true,
    date: true,
    name: true,
    uxos: true,
    mines: true,
    hand_over_files: true,
    hand_over_remarks: true,
  },
  comments_summary: {
    comments_summary: true,
    imsma_comments_summary: true,
    status_manually_changed: true,
    display_validation_status: true,
  },
};

const CLEARANCE_WEEKLY_DEFAULT_FIELDS = {
  dms: {
    user: true,
    donor: true,
    task_customer: true,
    team_id: true,
    report_date: true,
    maintenance_day: true,
    reporter_position: true,
    reporter_organization: true,
    maintenance_day_exists: true,
  },
  marking: {
    area: true,
    points: true,
    marking_files: true,
    marking_remarks: true,
  },
  created_at: {
    created_at: true,
  },
  field_work: {
    region: true,
    remarks: true,
    district: true,
    eo_found: true,
    task_type: true,
    local_community: true,
    settlement_name: true,
    daily_progress_polygon: true,
    clearance_task_imsma_id: true,
    field_work_cleared_area: true,
    deminer_progress_polygon: true,
    number_of_deminers_on_the_field: true,
  },
  cl_daily_id: {
    id: true,
  },
  eo_found_tab: {
    ied: true,
    saa: true,
    date: true,
    name: true,
    uxos: true,
    mines: true,
    hand_over_files: true,
    hand_over_remarks: true,
  },
  comments_summary: {
    comments_summary: true,
    imsma_comments_summary: true,
    status_manually_changed: true,
    display_validation_status: true,
  },
};

const CLEARANCE_BLOCKS = {
  ha: false,
  gis: false,
  tcp: false,
  team: false,
  files: false,
  cl_task_id: false,
  created_at: false,
  progress_map: false,
  comments_summary: false,
};

const CLEARANCE_DAILY_BLOCKS = {
  dms: false,
  field_work: false,
  marking: false,
  eo_found_tab: false,
  cl_daily_id: false,
  created_at: false,
  comments_summary: false,
};

const CLEARANCE_WEEKLY_BLOCKS = {
  dms: false,
  field_work: false,
  marking: false,
  eo_found_tab: false,
  cl_daily_id: false,
  created_at: false,
  comments_summary: false,
};

export const NewTemplate = (props) => {
  const [open, setOpen] = useState(false);
  const [reportName, setReportName] = useState(null);

  const [selectedNtsBlocks, setSelectedNtsBlocks] = useState(JSON.parse(JSON.stringify(NTSBlocks)));
  const [selectedHaBlocks, setSelectedHaBlocks] = useState(JSON.parse(JSON.stringify(HABlocks)));
  const [selectedEoreBlocks, setSelectedEoreBlocks] = useState(
    JSON.parse(JSON.stringify(EOREBlocks)),
  );

  const [selectedNtsAttr, setSelectedNtsAttr] = useState(JSON.parse(JSON.stringify(NTSTemplate)));
  const [selectedHaAttr, setSelectedHaAttr] = useState(JSON.parse(JSON.stringify(HATemplate)));
  const [selectedEoreAttr, setSelectedEoreAttr] = useState(
    JSON.parse(JSON.stringify(EORETemplate)),
  );
  const [selectedClearanceAttr, setSelectedClearanceAttr] = useState(JSON.parse(JSON.stringify(CLEARANCE_DEFAULT_FIELDS)));
  const [selectedClearanceBlocks, setSelectedClearanceBlocks] = useState(JSON.parse(JSON.stringify(CLEARANCE_BLOCKS)));
  const [selectedClearanceDailyAttr, setSelectedClearanceDailyAttr] = useState(JSON.parse(JSON.stringify(CLEARANCE_DAILY_DEFAULT_FIELDS)));
  const [selectedClearanceDailyBlocks, setSelectedClearanceDailyBlocks] = useState(JSON.parse(JSON.stringify(CLEARANCE_DAILY_BLOCKS)));
  const [selectedClearanceWeeklyAttr, setSelectedClearanceWeeklyAttr] = useState(JSON.parse(JSON.stringify(CLEARANCE_WEEKLY_DEFAULT_FIELDS)));
  const [selectedClearanceWeeklyBlocks, setSelectedClearanceWeeklyBlocks] = useState(JSON.parse(JSON.stringify(CLEARANCE_WEEKLY_BLOCKS)));

  const { user } = useUser();

  const reportTypeOptions = [
    { value: 'nts', label: 'NTS' },
    { value: 'ha', label: 'HA' },
    { value: 'eore', label: 'EORE' },
    { value: 'clearance', label: 'Clearance Task' },
    { value: 'cl_daily', label: 'Clearance Daily' },
    { value: 'cl_weekly', label: 'Clearance Weekly' },
  ];
  const [reportType, setReportType] = useState(reportTypeOptions[0]);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedHaBlocks(JSON.parse(JSON.stringify(HABlocks)));
    setSelectedNtsBlocks(JSON.parse(JSON.stringify(NTSBlocks)));
    setSelectedNtsAttr(JSON.parse(JSON.stringify(NTSTemplate)));
    setSelectedHaAttr(JSON.parse(JSON.stringify(HATemplate)));
    setSelectedEoreBlocks(JSON.parse(JSON.stringify(EOREBlocks)));
    setSelectedEoreAttr(JSON.parse(JSON.stringify(EORETemplate)));
    setSelectedClearanceAttr(JSON.parse(JSON.stringify(CLEARANCE_DEFAULT_FIELDS)));
    setSelectedClearanceBlocks(JSON.parse(JSON.stringify(CLEARANCE_BLOCKS)));
    setSelectedClearanceDailyAttr(JSON.parse(JSON.stringify(CLEARANCE_DAILY_DEFAULT_FIELDS)));
    setSelectedClearanceDailyBlocks(JSON.parse(JSON.stringify(CLEARANCE_DAILY_BLOCKS)));
    setSelectedClearanceWeeklyAttr(JSON.parse(JSON.stringify(CLEARANCE_WEEKLY_DEFAULT_FIELDS)));
    setSelectedClearanceWeeklyBlocks(JSON.parse(JSON.stringify(CLEARANCE_WEEKLY_BLOCKS)));

    setReportName(null);
    setReportType(reportTypeOptions[0]);
  };

  const uploadNewTemplate = () => {
    let fields;
    if (!reportName) {
      toast.warning('You need to set template name');
      return;
    }
    if (reportType.value === 'nts') {
      fields = selectedNtsAttr;
    } else if (reportType.value === 'ha') {
      fields = selectedHaAttr;
    } else if (reportType.value === 'eore') {
      fields = selectedEoreAttr;
    } else if (reportType.value === 'clearance') {
      fields = selectedClearanceAttr;
    } else if (reportType.value === 'cl_daily') {
      fields = selectedClearanceDailyAttr;
    } else if (reportType.value === 'cl_weekly') {
      fields = selectedClearanceWeeklyAttr;
    }
    props.setLoader(true);
    axiosWrapper(() => {
      const typeToSend = reportType.value === 'clearance' ? 'cl_task' : reportType.value;
      axios.post('/templates/', {
        fields,
        name: reportName,
        type: typeToSend,
      })
        .then((res) => {
          if (res.status === 201) {
            handleClose();
            toast.success('Template was created');
            props.getTemplates(1);
          }
          props.setLoader(false);
        })
        .catch((err) => {
          console.error(err);
          toast.error('Error creating template.');
          props.setLoader(false);
        });
    });
  };

  const findKey = (obj, targetKey, blocks) => {
    if (blocks && blocks.hasOwnProperty(targetKey)) {
      return blocks[targetKey];
    }


    const search = (source) => {
      for (const key in source) {
        if (source.hasOwnProperty(key)) {
          if (key === targetKey) {
            if (typeof source[key] === 'object' && source[key] !== null) {
              return Object.values(source[key]).some((val) => {
                if (typeof val === 'boolean') return val;
                if (typeof val === 'object' && val !== null) {
                  return Object.values(val).some((v) => (typeof v === 'boolean' ? v : false));
                }
                return false;
              });
            }
            return source[key];
          } if (typeof source[key] === 'object') {
            const result = search(source[key]);
            if (result !== undefined) {
              return result;
            }
          }
        }
      }
      return undefined;
    };

    const found = search(obj);
    return found === undefined ? false : found;
  };

  const updateBlockToBool = (block, template, bool) => {
    const setAllBoolsRecursive = (obj) => {
      if (!obj || typeof obj !== 'object') return;
      for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
          if (typeof obj[key] === 'boolean') {
            obj[key] = bool;
          } else if (typeof obj[key] === 'object' && obj[key] !== null) {
            setAllBoolsRecursive(obj[key]);
          }
        }
      }
    };

    if (template[block]) {
      setAllBoolsRecursive(template[block]);
    }
    return { ...template };
  };

    const handleTemplateBlockCheckbox = (block, attribute, isChecked) => {

    if (reportType.value === 'nts') {
      setSelectedNtsBlocks((prevSelect) => ({
        ...prevSelect,
        [block]: isChecked,
      }));
      if (selectedNtsBlocks.hasOwnProperty(block)) {
        // eslint-disable-next-line no-use-before-define
        setSelectedNtsAttr(updateBlockToBool(block, selectedNtsAttr, isChecked));
      }
    } else if (reportType.value === 'ha') {
      if (selectedHaBlocks.hasOwnProperty(block) && typeof (block) !== 'object') {
        setSelectedHaBlocks((prevSelect) => ({
          ...prevSelect,
          [block]: isChecked,
        }));
        // eslint-disable-next-line no-use-before-define
        setSelectedHaAttr(updateBlockToBool(block, selectedHaAttr, isChecked));
      }
    } else if (reportType.value === 'eore') {
      if (selectedEoreBlocks.hasOwnProperty(block) && typeof (block) !== 'object') {
        setSelectedEoreBlocks((prevSelect) => ({
          ...prevSelect,
          [block]: isChecked,
        }));
        setSelectedEoreAttr(updateBlockToBool(block, selectedEoreAttr, isChecked));
      }
    } else if (reportType.value === 'clearance') {
      setSelectedClearanceBlocks((prevSelect) => ({
        ...prevSelect,
        [block]: isChecked,
      }));
      setSelectedClearanceAttr(updateBlockToBool(block, selectedClearanceAttr, isChecked));
    } else if (reportType.value === 'cl_daily') {
      setSelectedClearanceDailyBlocks((prevSelect) => ({
        ...prevSelect,
        [block]: isChecked,
      }));
      setSelectedClearanceDailyAttr(updateBlockToBool(block, selectedClearanceDailyAttr, isChecked));
    } else if (reportType.value === 'cl_weekly') {
      setSelectedClearanceWeeklyBlocks((prevSelect) => ({
        ...prevSelect,
        [block]: isChecked,
      }));
      setSelectedClearanceWeeklyAttr(updateBlockToBool(block, selectedClearanceWeeklyAttr, isChecked));
    }
  };

  const handleAttributeCheckbox = (template, blocks, key, bool) => {
    const blockNames = key.split('__');
    if (reportType.value === 'ha') {
      if (blockNames[2]
        && !blocks.hasOwnProperty(blockNames[2])
        && typeof (template[blockNames[0]][blockNames[1]][blockNames[2]]) !== 'object') {
        setSelectedHaAttr((prevAttr) => ({
          ...prevAttr,
          [blockNames[0]]: {
            ...prevAttr[blockNames[0]],
            [blockNames[1]]: {
              ...prevAttr[blockNames[0]][blockNames[1]],
              [blockNames[2]]: bool,
            },
          },
        }));
        return;
      }
      if (blockNames[1]
        && typeof (template[blockNames[0]][blockNames[1]]) !== 'object') {
        setSelectedHaAttr((prevAttr) => ({
          ...prevAttr,
          [blockNames[0]]: {
            ...prevAttr[blockNames[0]],
            [blockNames[1]]: bool,
          },
        }));
        return;
      }
      if (blockNames[0]
        && !blocks.hasOwnProperty(blockNames[0])
        && typeof (template[blockNames[0]]) !== 'object') {
        setSelectedHaAttr((prevAttr) => ({
          ...prevAttr,
          [blockNames[0]]: bool,
        }));
        return;
      }
    }
    if (reportType.value === 'nts') {
      if (blockNames[1]
        && !blocks.hasOwnProperty(blockNames[1])
        && typeof (template[blockNames[1]]) !== 'object') {
        setSelectedNtsAttr((prevAttr) => ({
          ...prevAttr,
          [blockNames[0]]: {
            ...prevAttr[blockNames[0]],
            [blockNames[1]]: bool,
          },
        }));
        return;
      }
      if (blockNames[0]
        && !blocks.hasOwnProperty(blockNames[0])
        && typeof (template[blockNames[0]]) !== 'object') {
        setSelectedNtsAttr((prevAttr) => ({
          ...prevAttr,
          [blockNames[0]]: bool,
        }));
      }
    }
    if (reportType.value === 'eore') {
      if (blockNames[2]
        && !blocks.hasOwnProperty(blockNames[2])
        && typeof (template[blockNames[0]][blockNames[1]][blockNames[2]]) !== 'object') {
        setSelectedEoreAttr((prevAttr) => ({
          ...prevAttr,
          [blockNames[0]]: {
            ...prevAttr[blockNames[0]],
            [blockNames[1]]: {
              ...prevAttr[blockNames[0]][blockNames[1]],
              [blockNames[2]]: bool,
            },
          },
        }));
        return;
      }
      if (blockNames[1]
        && typeof (template[blockNames[0]][blockNames[1]]) !== 'object') {
        setSelectedEoreAttr((prevAttr) => ({
          ...prevAttr,
          [blockNames[0]]: {
            ...prevAttr[blockNames[0]],
            [blockNames[1]]: bool,
          },
        }));
        return;
      }
      if (blockNames[0]
        && !blocks.hasOwnProperty(blockNames[0])
        && typeof (template[blockNames[0]]) !== 'object') {
        setSelectedEoreAttr((prevAttr) => ({
          ...prevAttr,
          [blockNames[0]]: bool,
        }));
      }
    }
  };

  return (
    user?.permissions?.add_templates
    && (
      <div className="drone-new-btn">
        <ButtonComponent
          iconLeft={<DownloadSvg />}
          handleButton={handleClickOpen}
          label="Add template"
          className=""
        />
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          maxWidth="lg"
          className="templates-modal"
        >
          <div className="confirm-popup popup">
            <div className="header">
              <span className="title">Add template</span>
              <span className="closeBtn" onClick={handleClose} />
            </div>

            <div className="flex-column-group">
              <div className="flex-group">
                <InputComponent
                  id="template-name"
                  name="template-name"
                  iconLeft={<ShedulleSvg />}
                  value={reportName}
                  handleInput={setReportName}
                  label="Template name"
                  classNameWrapper="align-left"
                  placeholder="Enter name"
                />
                <div className="label-input w-100">
                  <span>Report type</span>
                  <SelectComponent
                    id="drone-report"
                    name="drone-report"
                    label="Report"
                    className="full"
                    placeholder={(
                      <div>
                        <ShedulleSvg />
                        <span>Select report type</span>
                      </div>
                    )}
                    value={reportType?.value
                      ? { value: reportType.value, label: reportType.label }
                      : null}
                    handleSelect={(value, label) => {
                      setReportType({ value, label });
                    }}
                    options={reportTypeOptions}
                    isMulti={false}
                    isDisabled={false}
                  />
                </div>
              </div>
              <div className="label-input">
                <span>Attributes</span>
                <div className="template-attributes">
                  {reportType?.value === 'nts'
                    && (
                      <NTSAttributesBlock
                        reportType={reportType}
                        selectedNtsBlocks={selectedNtsBlocks}
                        findKey={findKey}
                        handleTemplateBlockCheckbox={handleTemplateBlockCheckbox}
                        selectedNtsAttr={selectedNtsAttr}
                        handleTemplateCheckbox={handleAttributeCheckbox}
                        NTSAttributes={props.NTSAttributes}
                      />
                    )}
                  {reportType?.value === 'ha'
                    && (
                      <HAAttributesBlock
                        reportType={reportType}
                        selectedHaBlocks={selectedHaBlocks}
                        findKey={findKey}
                        handleTemplateBlockCheckbox={handleTemplateBlockCheckbox}
                        selectedHaAttr={selectedHaAttr}
                        handleTemplateCheckbox={handleAttributeCheckbox}
                        HAAttributes={props.HAAttributes}
                      />
                    )}
                  {reportType?.value === 'eore'
                    && (
                      <EoreAttributesBlock
                        reportType={reportType}
                        selectedEoreBlocks={selectedEoreBlocks}
                        findKey={findKey}
                        handleTemplateBlockCheckbox={handleTemplateBlockCheckbox}
                        selectedEoreAttr={selectedEoreAttr}
                        handleTemplateCheckbox={handleAttributeCheckbox}
                        EoreAttributes={props.EoreAttributes}
                      />
                    )}
                  {reportType?.value === 'clearance' && (
                    <NTSAttributesBlock
                      reportType={reportType}
                      selectedNtsBlocks={selectedClearanceBlocks}
                      findKey={(obj, targetKey, blocks) => {
                         const isLocationOrPolygon = targetKey === 'location' || targetKey === 'turn_points';

                         if (isLocationOrPolygon) {
                           console.log(`[clearance findKey] ${targetKey}:`, {
                             obj: obj,
                             blocks: blocks
                           });
                         }

                         for (const key in obj) {
                           if (obj.hasOwnProperty(key)) {
                             if (key === targetKey) {
                               if (typeof obj[key] === 'object' && obj[key] !== null) {
                                 const hasTrue = Object.values(obj[key]).some(val => {
                                   if (typeof val === 'boolean') return val;
                                   if (typeof val === 'object' && val !== null) {
                                     return Object.values(val).some(v => typeof v === 'boolean' ? v : false);
                                   }
                                   return false;
                                 });
                                 if (isLocationOrPolygon) {
                                   console.log(`[clearance findKey] ${targetKey} found (object):`, obj[key], 'hasTrue:', hasTrue);
                                 }
                                 return hasTrue;
                               }
                               if (isLocationOrPolygon) {
                                 console.log(`[clearance findKey] ${targetKey} found (primitive):`, obj[key]);
                               }
                               return obj[key];
                             }
                             if (typeof obj[key] === 'object') {
                               const result = findKey(obj[key], targetKey, blocks);
                               if (result !== undefined && result !== false) {
                                 if (isLocationOrPolygon) {
                                   console.log(`[clearance findKey] ${targetKey} found recursively:`, result);
                                 }
                                 return result;
                               }
                             }
                           }
                         }

                         if (blocks && blocks.hasOwnProperty(targetKey)) {
                           const result = blocks[targetKey];
                           if (isLocationOrPolygon) {
                             console.log(`[clearance findKey] ${targetKey} found in blocks:`, result);
                           }
                           return result;
                         }

                         if (isLocationOrPolygon) {
                           console.log(`[clearance findKey] ${targetKey} not found, returning false`);
                         }
                         return false;
                       }}
                      handleTemplateBlockCheckbox={handleTemplateBlockCheckbox}
                      selectedNtsAttr={selectedClearanceAttr}
                      handleTemplateCheckbox={(tpl, blocks, key, bool) => {
                        const names = key.split('__');
                        setSelectedClearanceAttr((prev) => {
                          const draft = JSON.parse(JSON.stringify(prev));
                          let cursor = draft;
                          for (let i = 0; i < names.length - 1; i += 1) {
                            const nextKey = names[i];
                            if (!cursor[nextKey] || typeof cursor[nextKey] !== 'object') {
                              cursor[nextKey] = {};
                            }
                            cursor = cursor[nextKey];
                          }

                          const targetKey = names[names.length - 1];
                          const targetValue = cursor[targetKey];

                          if (typeof targetValue === 'object' && targetValue !== null) {
                            const setAllBoolsRecursive = (obj) => {
                              for (const k in obj) {
                                if (obj.hasOwnProperty(k)) {
                                  if (typeof obj[k] === 'boolean') {
                                    obj[k] = bool;
                                  } else if (typeof obj[k] === 'object' && obj[k] !== null) {
                                    setAllBoolsRecursive(obj[k]);
                                  }
                                }
                              }
                            };
                            setAllBoolsRecursive(targetValue);
                          } else {
                            cursor[targetKey] = bool;
                          }

                          return draft;
                        });
                      }}
                      NTSAttributes={props.ClearanceAttributes || CLEARANCE_SCHEMA}
                    />
                  )}
                  {reportType?.value === 'cl_daily' && (
                    <NTSAttributesBlock
                      reportType={reportType}
                      selectedNtsBlocks={selectedClearanceDailyBlocks}
                      findKey={findKey}
                      handleTemplateBlockCheckbox={handleTemplateBlockCheckbox}
                      selectedNtsAttr={selectedClearanceDailyAttr}
                      handleTemplateCheckbox={(tpl, blocks, key, bool) => {
                        const names = key.split('__');
                        setSelectedClearanceDailyAttr((prev) => {
                          const draft = JSON.parse(JSON.stringify(prev));
                          let cursor = draft;
                          for (let i = 0; i < names.length - 1; i += 1) {
                            const nextKey = names[i];
                            if (!cursor[nextKey] || typeof cursor[nextKey] !== 'object') {
                              cursor[nextKey] = {};
                            }
                            cursor = cursor[nextKey];
                          }

                          const targetKey = names[names.length - 1];
                          const targetValue = cursor[targetKey];

                          if (typeof targetValue === 'object' && targetValue !== null) {
                            const setAllBoolsRecursive = (obj) => {
                              for (const k in obj) {
                                if (obj.hasOwnProperty(k)) {
                                  if (typeof obj[k] === 'boolean') {
                                    obj[k] = bool;
                                  } else if (typeof obj[k] === 'object' && obj[k] !== null) {
                                    setAllBoolsRecursive(obj[k]);
                                  }
                                }
                              }
                            };
                            setAllBoolsRecursive(targetValue);
                          } else {
                            cursor[targetKey] = bool;
                          }

                          return draft;
                        });
                      }}
                      NTSAttributes={CLEARANCE_DAILY_SCHEMA}
                    />
                  )}
                  {reportType?.value === 'cl_weekly' && (
                    <NTSAttributesBlock
                      reportType={reportType}
                      selectedNtsBlocks={selectedClearanceWeeklyBlocks}
                      findKey={findKey}
                      handleTemplateBlockCheckbox={handleTemplateBlockCheckbox}
                      selectedNtsAttr={selectedClearanceWeeklyAttr}
                      handleTemplateCheckbox={(tpl, blocks, key, bool) => {
                        const names = key.split('__');
                        setSelectedClearanceWeeklyAttr((prev) => {
                          const draft = JSON.parse(JSON.stringify(prev));
                          let cursor = draft;
                          for (let i = 0; i < names.length - 1; i += 1) {
                            const nextKey = names[i];
                            if (!cursor[nextKey] || typeof cursor[nextKey] !== 'object') {
                              cursor[nextKey] = {};
                            }
                            cursor = cursor[nextKey];
                          }
                          const targetKey = names[names.length - 1];
                          const targetValue = cursor[targetKey];
                          if (typeof targetValue === 'object' && targetValue !== null) {
                            const setAll = (obj) => {
                              for (const k in obj) {
                                if (obj.hasOwnProperty(k)) {
                                  if (typeof obj[k] === 'boolean') obj[k] = bool;
                                  else if (typeof obj[k] === 'object' && obj[k] !== null) setAll(obj[k]);
                                }
                              }
                            };
                            setAll(targetValue);
                          } else {
                            cursor[targetKey] = bool;
                          }
                          return draft;
                        });
                      }}
                      NTSAttributes={CLEARANCE_WEEKLY_SCHEMA}
                    />
                  )}
                </div>
              </div>

            </div>
            <div className="buttons-group">
              <ButtonComponent
                className="danger"
                iconLeft={<CancelSvg />}
                handleButton={() => {
                  handleClose();
                }}
                label="Cancel"
              />
              <ButtonComponent
                iconLeft={<AddSvg />}
                handleButton={uploadNewTemplate}
                label="Add template"
              />
            </div>
          </div>
        </Dialog>
      </div>
    )
  );
};
